<template>
  <div class="account-details overflow-y-hidden flex-grow-1 d-flex flex-column">
    <div class="a-header">
      <span class="a-header--title">
        My Account
      </span>
      <div>
        <span>
          {{ userDetail.timezone }}
          <a class="btn-edit ml-2" @click="showEditTimeZoneModal()">
            Edit
          </a>
        </span>
      </div>
    </div>
    <div class="a-body p-20-px flex-grow-1">
      <h3 class="info-title">
        Personal info
      </h3>
      <div class="info-item">
        <a-row>
          <a-col :span="4">
            <span class="info-item__label">
              Email
            </span>
          </a-col>
          <a-col :span="20">
            <span class="info-item__value">
              {{ userDetail.username }}
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <span class="info-item__label">
              Company
            </span>
          </a-col>
          <a-col :span="20">
            <span class="info-item__value">
              {{ userDetail.company }}
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <span class="info-item__label">
              Timezone
            </span>
          </a-col>
          <a-col :span="20">
            <span class="info-item__value">
              {{ userDetail.timezone }}
            </span>
            <a class="btn-edit ml-2" @click="showEditTimeZoneModal()">
              Edit
            </a>
          </a-col>
        </a-row>
      </div>
      <a-row>
        <a-col :span="12">
          <h3 class="info-title mt-4">
            Plan
          </h3>
          <div class="info-item">
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Gold
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.gold_limit }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Silver
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.silver_limit }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Bronze
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.bronze_limit }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Trial
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.trial_limit }}
                </span>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="12">
          <h3 class="info-title mt-4">
            Others
          </h3>
          <div class="info-item">
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  SMS Limit
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.sms_balance }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Created at
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.create_date | dateString }}
                  {{ userDetail.create_date | timeString }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <span class="info-item__label">
                  Expires at
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.expiry_date | dateString }}
                  {{ userDetail.expiry_date | timeString }}
                </span>
              </a-col>
            </a-row>
            <a-row>
              <!--<a-col :span="8">
                <span class="info-item__label">
                  Last Signed in
                </span>
              </a-col>
              <a-col :span="16">
                <span class="info-item__value">
                  {{ userDetail.last_login | dateString }}
                  {{ userDetail.last_login | timeString }}
                </span>
              </a-col>-->
            </a-row>
          </div>
        </a-col>
      </a-row>
    </div>

    <!-- Modal Change Timezone -->
    <a-modal
      v-model="isShowChangeTimezone"
      class="change-timezone-modal"
      :footer="null"
      title="Change Timezone"
      onOk="onSubmitTimezone"
    >
      <a-form :form="timezoneForm" @submit="onSubmitTimezone">
        <div class="current-timezone">
          Current Timezone:
          <span class="fw-b">
            {{ userDetail.timezone }}
          </span>
        </div>
        <a-form-item class="mt-2" label="Timezone">
          <a-select
            v-decorator="[
              'timezone',
              {
                rules: [{ required: true, message: 'Please select timezone' }],
              },
            ]"
            showSearch
            size="large"
            :filterOption="filterTimezone"
          >
            <a-select-option
              v-for="timezone in timezoneList"
              :key="timezone.name"
            >
              {{ timezone.name }} {{ timezone.offset }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div class="a-footer">
          <a-button
            key="back"
            class="mr-3"
            @click="isShowChangeTimezone = false"
          >
            Cancel
          </a-button>
          <a-button
            key="submit"
            :disabled="!timezoneForm.getFieldValue('timezone')"
            type="primary"
            html-type="submit"
            @click="onSubmitTimezone"
          >
            Save
          </a-button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  debounceTimeExecute,
  flatMapErrMessagesValidateForm,
} from "@shared/helpers/utils";
import AccountService from "../services/account.service";
import DataService from "@shared/services/data.service";
import { UserDate } from "@shared/services/userDate.service";

export default {
  name: "Details",
  data() {
    return {
      userDetail: {},
      isShow2FA: false,
      isShowChangeTimezone: false,
      timezoneList: [],
      secret2FA: {},
    };
  },
  beforeCreate() {
    this.timezoneForm = this.$form.createForm(this, {
      name: "normal_change_timezone",
    });
  },
  mounted() {
    this.getUser();
    this.getTimezoneList();
  },
  methods: {
    showEditTimeZoneModal() {
      this.isShowChangeTimezone = true;
      this.timezoneForm.setFieldsValue({ timezone: this.userDetail.timezone });
    },
    onSubmitTimezone(e) {
      e.preventDefault();
      this.timezoneForm.validateFields((err, values) => {
        if (!err) {
          AccountService.updateUserInRole(values).then((userDetail) => {
            if (userDetail) {
              this.isShowChangeTimezone = false;
              this.userDetail.timezone = userDetail.timezone;
              new UserDate().setUserTimezone(userDetail.timezone);
              this.getUser();
              this.$showSuccessMessage("Updated Timezone!");
            }
          });
        }
      });
    },
    async getUser() {
      const userDetail = await AccountService.getUserInRole();
      this.userDetail = {
        ...userDetail,
        enable_2fa: !!userDetail.enable_2fa,
      };
      this.$store.dispatch('SETUSER', this.userDetail);
    },
    async getTimezoneList() {
      this.timezoneList = await DataService.getTimezones();
    },
    filterTimezone(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-edit {
  text-decoration: underline;
}

.info-item {
  .ant-row {
    height: 60px;
    line-height: 60px;
    border-bottom: solid 1px $border;
  }

  &__label {
    color: $prLgt;
    font-size: 13px;
  }

  &__value {
    color: $pr;
    font-size: 13px;
  }
}

.qr-code {
  width: 160px;
  height: 240px;

  &--img {
    margin: auto;
    text-align: center;
  }

  &--text {
    font-size: 11px;
    color: $pr;
    text-align: center;
  }
}

.current-timezone {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 0 20px;
}

.active-2fa-modal,
.change-timezone-modal {
  width: 580px !important;
  .ant-modal-body span {
    color: $pr;
    font-size: 13px;
  }

  .ant-btn {
    min-width: 100px;
  }

  .a-footer {
    margin: 50px -25px -25px -25px;
  }

  .ant-btn.ant-btn-primary span {
    color: #ffffff;
  }
}
</style>
